import {Spinner} from "atmosfair-ui";
import React from "react";
import "./styles.css"

const SpinnerForKlimaLinkAdmin = () => <div className={"spinner-for-klimalink-admin-container"}>
    <Spinner size={40}
             fullPage={false}/>
</div>

export default SpinnerForKlimaLinkAdmin